<template>
  <hr
    v-if="$props.readonly && model"
    :style="{
      marginTop: parseFloat((model.meta?.spacing_top ?? 1) + '') + 'rem',
      marginBottom: parseFloat((model.meta?.spacing_bottom ?? 1) + '') + 'rem'
    }"
    >
  <blog-content-edit-wrapper v-else-if="model" v-model="model">
    <div v-if="model.meta">
      <ui-text
        :id="'spacing_'+model.id"
        v-model="model.meta.spacing_top"
        label="Spacing top"
        />
      <ui-text
        :id="'spacing_'+model.id"
        v-model="model.meta.spacing_bottom"
        label="Spacing bottom"
        />
    </div>
  </blog-content-edit-wrapper>
</template>

<script setup lang="ts">
defineEmits(['remove'])
defineProps<{ readonly?: boolean }>()

const model = defineModel<BlogElement>()

onMounted(() => {
  if (!model.value) model.value = {} as BlogElement
  if (!model.value.meta) model.value.meta = {} as BlogElementMeta
  if (!model.value.meta.spacing_top) model.value.meta.spacing_top = 1
  if (!model.value.meta.spacing_bottom) model.value.meta.spacing_bottom = 1
})
</script>
